import React from 'react';
import AlertaReutilizavel from './AlertaReutilizavel';
import { useAlerta } from '../../hooks/useAlerta';

/**
 * Ponto único de render do alerta no app.
 *
 * Montado uma vez no `App`, garante que dois avisos (ação do usuário,
 * notificação em tempo real, erro de API, ...) nunca se sobreponham: a fila
 * global do `alertaStore` mostra um por vez.
 */
const AlertaHost = () => {
  const { alerta, hideAlerta } = useAlerta();

  if (!alerta.aberto) return null;

  return (
    <AlertaReutilizavel
      id={alerta.id}
      aberto={alerta.aberto}
      mensagem={alerta.mensagem}
      tipo={alerta.tipo}
      titulo={alerta.titulo}
      autoHideDuration={alerta.autoHideDuration}
      posicao={alerta.posicao}
      variant={alerta.variant}
      acao={alerta.acao}
      onFechar={hideAlerta}
    />
  );
};

export default AlertaHost;
